<template>
    <div>
        <div class="clas">
            <div class="clas_left" @click="phone">立即 咨询</div>
            <div class="clas_right" @click="phone">
                <img src="../assets/img/矩形@2x (3).png">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        phone() {
            this.$alert('15651101746', '王经理', {
                confirmButtonText: '确定',
                callback: action => {

                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
.clas {
    width: 120px;
    position: sticky;
    bottom: 10%;
    left: 99%;
    display: flex;
    align-items: center;

    .clas_left {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 35px;
        height: 35px;
        background: #2CABFD;
        box-shadow: 0px 0 5px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 300;
        font-size: 12px;
        color: #FFFFFF;
        margin-right: 20px;
        cursor: pointer;
    }

    .clas_right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 35px;
        height: 35px;
        background: #FFFFFF;
        box-shadow: 0px 0 5px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        cursor: pointer;

        img {
            width: 16px;
            height: 16px;
        }
    }
}
</style>